<template>
  <v-container fluid class="pa-0">

    <v-progress-linear v-if="loading" indeterminate height="1"></v-progress-linear>
    <v-divider v-else style="border-color: rgb(151 151 151 / 12%);" />

    <RouteListItem v-for="(tpl, index) in resolvedRows" :key="tpl.key || index" :node="{
      name: 'EditEmailSetting',
      meta: {
        displayName: tpl.title,
        icon: 'mdi-email-newsletter',
        params: { emailTemplate: tpl.key }
      }
    }">
    </RouteListItem>

    <!-- <v-divider class="mx-4" style="border-color: rgb(151 151 151 / 12%);" /> -->

  </v-container>
</template>


<script>
import RouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Base.vue";
import EmailTemplatesMixin from "@/views/admin/settings/email/EmailTemplatesMixin.js";

export default {
  name: "RouteListItem_Settings",
  props: {
    node: Object,
  },
  components: {
    RouteListItem,
  },
  mixins: [EmailTemplatesMixin],

  data() {
    return {
      loading: false,
    };
  },

  async mounted() {
    try {
      this.loading = true;
      await this.fetchTemplates();
    } finally {
      this.loading = false;
    }
  },

  methods: {},

  computed: {

  },

  watch: {

  },
};
</script>


<style lang='scss' scoped></style>